module.exports = __webpack_public_path__ + "static/media/Imperial College Union Indonesian Society.320e2bf4.png";